export const getrolesquery = `
   {
    allRoles {
      id
      role
      roleDescription
      roleGroupId
      roleGroup
      isActive
      statusFlag
      createdBy
      createdDate
      updatedBy
      updatedDate
      companyId
      company
    }
  }
  `;
export const AllModules = `
    {
    allModules {
      id
      module
      isActive
      statusFlag
      createdBy
      createdDate
      updatedBy
      updatedDate
      companyId
      company
    }
  }
  `;



export const allCasesDynamic = `{
  allCasesDynamicView {
    assignedTo
    caseNumber
    caseStatus
    categoryName
    clientType
    companyName
    createdBy
    createdDate
    dateClosed
    dateOpened
    description
    id
    isActive
    isInvoiced
    priority
    statusFlag
    subcategoryName
    summary
    title
    updatedBy
    updatedDate
  }
}`;

export const caseCategory = `{
  allCaseCategories {
    id
    categoryName
    description
    companyId
    company
  }
}`;
export const caseStatus = `{
    allCaseStatus {
        id
        status
    }
}`;
export const caseSubCategory = `
{
  allCaseSubcategories {
    id
    categoryId
    categoryName
    subcategoryName
    description
    companyId
  }
}`;

export const caseEvents = `
{
  allCaseEvents {
    id
    caseId
    eventTypeId
    eventType
    eventDate
    outcome
    hearingDate
    description
    createdBy
    createdDate
    companyId
    company
  }
}
`;

export const caseTasks = `{
  allCaseTaskView {
    caseNumber
    companyName
    createdBy
    createdDate
    description
    dueDate
    id
    isActive
    name
    statusFlag
    updatedBy
    updatedDate
  }
}`;
export const allFacts = `{
  allFactView {
    caseNumber
    categoryName
    companyName
    createdBy
    createdDate
    factDate
    factDescription
    id
    updatedBy
    updatedDate
  }
}`;

export const allCasesEvents = `{
  allCaseEventsView {
    caseNumber
    companyName
    createdBy
    createdDate
    description
    eventDate
    eventType
    hearingDate
    id
    outcome
  }
}`;

export const allEventTypes = ` {
  allEventTypes {
      id
      eventType
      createdDate
      createdBy
      updatedBy
      updatedDate
      companyId
      company
  }
}
`;

export const allClientTypes = `{
  allClientTypes {
        id
        clientType
        createdDate
        createdBy
        updatedBy
        updatedDate
    }
}`;


export const allIndividualClients = `
{
  allIndividualClients {
    id
    firstName
    lastName
    dateOfBirth
    genderId
    gender
    nationality
    identificationType
    identificationNumber
    contactNumber
    email
    address
    occupation
    employer
    emergencyContactName
    emergencyContactNumber
    relationshipWithEmergencyContact
    dateAdded
    notes
    isActive
    statusFlag
    createdBy
    createdDate
    updatedBy
    updatedDate
    companyId
    company
    genderId
  }
}
`;

export const allCorporateClients = `
{
  allCorporateClients {
    id
    contactNumber
    email
    address
    dateAdded
    notes
    companyName
    registrationNumber
    industrySector
    contactPersonName
    contactPersonPosition
    contactPersonEmail
    contactPersonPhone
    companyAddress
    billingAddress
    incorporationDate
    legalStructure
    countryOfIncorporation
    taxIdentificationNumber
    authorizedSignatoryName
    authorizedSignatoryPosition
    authorizedSignatoryEmail
    authorizedSignatoryPhone
    isActive
    statusFlag
    createdBy
    createdDate
    updatedBy
    updatedDate
    companyId
    company
  }
}
`;
export const allUsersQuery = `{
    allUsers {
      id
      firstName
      username
      lastName
      idno
      phone
      gender
      email
      isActive
      roleName
    }
  }`;

export const allPayeeTypes = `{
    allPayeeTypes {
        id
        name
        code
        isActive
        createdDate
    }
}
`;
// export const  allSuppliers = `{
//     allSuppliers {
//         id
//         supplierName
//         contactNumber
//         email
//         address
//         registrationNumber
//         taxIdentificationNumber
//         contactPersonName
//         contactPersonEmail
//         contactPersonPhone
//         industrySector
//         dateAdded
//         notes
//         isActive
//         statusFlag
//         createdBy
//         createdDate
//         updatedBy
//         updatedDate
//         companyId
//         company
//     }
// } `;

export const allPaymentVouchers = `   {
    allPaymentVouchersView {
        id
        voucherNumber
        voucherDate
        description
        accountTypeId
        paymentAccountTypeName
        paymentAccountId
        paymentAccountName
        paymentModeId
        paymentModeName
        currencyId
        currencyCode
        exchangeRate
        totalAmount
        totalWithholdingTax
        netAmount
        referenceNumber
        statusId
        statusName
        approvedBy
        approvedByName
        approvedDate
        paymentDate
        companyId
        branchId
        isPosted
        isActive
        createdBy
        createdDate
        updatedBy
        updatedDate
        notes
    }
}
`;

export const allCourts = ` {
  allCourts {
    id
    court
    courtTypeId
    courtType
    countryId
    country
    countyId
    county
    subCountyId
    subCounty
    latitude
    longitude
    createdDate
    createdBy
    updatedBy
    updatedDate
    companyId
    company
  }
  }`;

//  export const allCompanies = `{
//    allCompanies {
//      id
//      companyName
//       subscriptionId
//        createdBy
//         createdDate 
//         updatedBy
//          updatedDate
//   }
//  }`;

export const allCompanies = `
{
  allCompanies {
        id
        companyName
        companyEmail
        contactEmail
        contactEmailPassword
        emailDisplayName
        emailClient
        emailClientPortNumber
        subscriptionId
        createdBy
        createdDate
        updatedBy
        updatedDate
        logoPath
        address
        poBox
        phone
        mobile
        website
        pinVat
        tagline
        active
    }
}
`;
export const allActiveCompanies = `
{
  allActiveCompanies {
        id
        companyName
        companyEmail
        contactEmail
        contactEmailPassword
        emailDisplayName
        emailClient
        emailClientPortNumber
        subscriptionId
        createdBy
        createdDate
        updatedBy
        updatedDate
        logoPath
        address
        poBox
        phone
        mobile
        website
        pinVat
        tagline
    }
}
`;


export const allCounties = `{
    allCounties {
      id
      county
      countyCode
      createdDate
      createdBy
      updatedBy
      updatedDate
    }
  }`;

export const allAccountTypes = ` 
  {
  allAccountTypes {
      id
      accountType
      company
      companyId
    }
  } `;
export const allAccountCategories = `{
  allAccountCategories {
      id
      categoryName
      companyId
    }
  }
  `;
export const allAccountSubCategories = ` {
  allAccountSubCategories {
       id
        accountCategoryId
        accountCategory
        accountCategoryName
        isActive
    }
  }
  `;

export const AllChartOfAccountsView = ` {
  allChartOfAccountsView {
       id
        accountNumber
        accountName
        category
        subCategory
        groupAccountId
        accountCategoryId
        sortOrder
        financialStatementType
        normalBalanceType
        balance
        identifierType
        accountType
        hierarchyPath
        levelSort
        isGrouped
        isSummary
        formattedBalance
        sortLevel1
        sortLevel2
        sortLevel3
        sortLevel4
        accountSubcategoryId
    }
  }
  `;
export const allAccounts = ` {
  allAccounts {
      id
      status
      accountName
      accountNumber
      accountType
      accountSubcategoryId
      companyId
      company
      currencyId
      currency
      isActive
      statusFlag
      createdBy
      createdDate
      updatedBy
      updatedDate
    }
  }
  `;
export const allPaymentTypes = `{
  allPaymentTypes {
      id
      paymentType
      company
      companyId
    }
  }
  `;
export const allSuppliers = `{
  allSuppliers {
    id
    supplierName
    contactNumber
    email
    address
    registrationNumber
    taxIdentificationNumber
    contactPersonName
    contactPersonEmail
    contactPersonPhone
    industrySector
    dateAdded
    notes
    isActive
    statusFlag
    createdBy
    createdDate
    updatedBy
    updatedDate
    companyId
    company
    balance
  }
}`;
export const allBanks = `{
  allBanks {
      id
      bankName
      bankSwiftCode
      finCode
      mobile
      createdDate
      createdBy
      email
      companyId
      company
    }
  }

  `;

export const allDocumentApprovers = `{
  allDocumentApprovers {
      id
      documentTypeId
      approverUserId
      isFinalApprover
      isActive
      createdDate
      createdBy
      companyId
    }
  }

  `;

export const AllDocumentsTypes = `{
  allDocumentsTypes {
      id
      documentTypeName
      documentClassId
      documentClassName
      documentCategory
      isActive
      createdDate
      createdBy
    }
  }

  `;

  export const AllDocumentsClass = `{
  allDocumentsClass {
      id
      documentClassTypeName
      isActive
      createdDate
      createdBy
    }
  }

  `;
export const allBankBranches = `{
  allBankBranches {
      id
      bankId
      branchCode
      branchName
      branchSwiftCode
      createdDate
      createdBy
      companyId
      company
      useInPrintout
      bankName
    }
  }
  `;
export const allBankBranchesView = `
{
  allBankBranchesViewByColumnValues(bankBranchesViewModel: {}) {
    id
    branchCode
    branchName
    branchSwiftCode
    bankName
    bankId
    useInPrintout
  }
}
`;


export const allBankAccounts = `{
  allBankAccounts {
      id
      bankId
      bankBranchId
      accountName
      accountNumber
      accountDescription
      status
      createdDate
      createdBy
      companyId
      company
    }
  }
  `;
export const allBanksBankBranchesAccountView = `{
    clientsBankAccountById {
      id
        status
        accountName
        accountNumber
        accountType
        companyId
        company
        currencyId
        currency
        isActive
        statusFlag
        createdBy
        createdDate
        updatedBy
        updatedDate
        identifierType
        identifierId
        accountSubcategoryId
        balance
        financialStatementType
        normalBalance
        closingBalance
    }
  }`;
export const allFiscalYears = `{
  allFiscalYears {
      id
      fiscalYearName
      startDate
      endDate
      status
      createdDate
      createdBy
      companyId
      company
    }
  }
  `;
export const allTaxAuthorities = `{
  allTaxAuthoritiesview {
    country
    id
    jurisdiction
    taxAuthorityName
  }
  }
  `;
export const allTaxRates = `{
  allTaxRates {
     id
        name
        rate
        taxAuthorityID
        paymentID
        companyId
        company
        countryId
        country
        taxTypeId
        taxTypeName
  }
  }
  `;

export const AllCurrency = `{
     currency {
        id
        currencyCode
        currencyName
        exchangeRate
        baseCurrencyId
        isActive
        createdBy
        createdDate
        updatedBy
        updatedDate
    }

  }`;

export const allJudgesQuery = `
  {
  allJudges {
      company
      companyId
      judgeId
      name
    }
  }
  `;

export const allCountries = `{
    allCountries {
      id
      country
      countryInitials
      createdDate
      createdBy
      updatedBy
      updatedDate
    }
  }`;
export const allRegions = `{
  allRegions {
    id
    regionName
    createdDate
    createdBy
    updatedBy
    updatedDate
    companyId
    company
  }
}
`;
export const allBranches = `
{
  allBranches {
    id
    branchName
    createdDate
    createdBy
    updatedBy
    updatedDate
    companyId
    company
    regionId
    region
  }
}
`;

export const allCompanyBranches = `
{
  allBranchesByColumnValues(branchModel: { companyId: 1 }) {
    id
    branchName
    createdDate
    createdBy
    updatedBy
    updatedDate
    companyId
    company
    regionId
    region}
}
`;

export const allCompanyBranchesView = `
{
    allBranchViewsByColumnValues(branch: { companyId: 1 }) {
        id
        branchName
        createdDate
        createdBy
        updatedBy
        updatedDate
        companyId
        company
        regionId
        region
  }
}
`;
export const allDepartments = `{
  allDepartments {
    id
    departmentName
    createdDate
    createdBy
    updatedBy
    updatedDate
    companyId
    company
  }
}`;
export const allAddOns = `
    {
  allAddOns {
    id
    addOnName
    description
    price
    isActive
    createdDate
    createdBy
    updatedBy
    updatedDate
  }
}
`;
export const allCompanyAddOns = `
  {
  allCompanyAddOns {
    id
    companyId
    addOnId
    addOn
    purchasedDate
    
    createdDate
    createdBy
    updatedBy
    updatedDate
  }
}

`;
export const allSubscriptionPlans = `
 {
  allSubscriptionPlans {
    id
    plan
    description
    price
    durationMonths
    storageLimit
    storageUnitId
    isActive
    createdDate
    createdBy
    updatedBy
    updatedDate
  }
}

`;
export const allStorageUnits = `
{
  allStorageUnits {
    id
    unit
    description
  }
}

`;
export const allSmsSettings = ` {
    smsSettings {
        companyId
        company
        active
        promotionalAmount
        transactionalAmount
        smsLimit
    }
  }
`;
export const notificationsAndCount = `{
    notificationsByUser {
        count
        notifications {
            notificationId
            userId
            notificationType
            body
            templateId
            isRead
            createdDate
            companyId
            company
        }
    }
}
`;

export const allCaseTask = `{
    allCaseTasks {
      id
      caseId
      asigneeId
      description
      isActive
      statusFlag
      createdBy
      createdDate
      updatedBy
      updatedDate
      companyId
      company
    }
  }`;
export const allCompanyEmailSettings = `{
  companyEmailSettingsById {
    companyId
    companyName
    companyEmail
    contactEmail
    contactEmailPassword
    emailClient
    emailClientPortNumber
    emailDisplayName
  }
}`;

export const allCourtAssignments = `{
    allCourtAssignments {
        id
        caseId
        courtId
        assignedDate
        createdBy
        createdDate
        companyId
        company
    }
}`;

export const allCaseEvents = `{
    allCaseEvents {
        id
        caseId
        eventTypeId
        eventType
        eventDate
        outcome
        hearingDate
        description
        createdBy
        createdDate
        companyId
        company
    }
}
`;

export const allJudgeAssignments = ` {
    allJudgeAssignments {
        id
        caseId
        judgeId
        assignedDate
        createdBy
        createdDate
        companyId
        company
    }
}
`;

export const allTeamAssignment = `{
    allTeamAssignmentView {
      assignedDate
      caseNumber
      companyName
      createdBy
      createdDate
      id
      isActive
      statusFlag
      updatedBy
      updatedDate
      userName
    }
  }`;
export const allCaseStatus = ` {
    allCaseStatus {
        id
        status
    }
}`;
export const mainDashboardQuery = `
  {
    companySummary {
        team
        numberOfCases
        numberOfCourtCases
        numberOfCorporateClients
        numberOfIndividualClients
        numberOfCaseEvents
        numberOfCaseTasks
        numberOfNewClients
        corporateClientPercentage
        individualClientPercentage
        courtCasePercentage
        casesClosed
        matterCompletion
        taskCompletion
        }

}

`;

export const allCasesView = `{
    allCasesView {
        id
        clientType
        caseNumber
        title
        description
        summary
        categoryName
       clientTypeId
        subcategoryName
        caseStatus
        dateOpened
        dateClosed
        priority
        isActive
        statusFlag
        createdBy
        createdDate
        updatedBy
        updatedDate
        isInvoiced
        companyId
        company
        regionId
        branchId
        individualFirstName
        individualLastName
        corporateCompanyName
        workFlow
        name
        clientId
        caseCategoryId
        caseSubCategoryId
        fileNumber
        assignedAdvocate
        associates
        balance

    }
}`;
// associate
// assignedAdvocate

/**
 * Time trackers Query
 */
export const timeTrackerQuery = `{
    getallTimeTrackers {
        id
        appliedDate
        userAssignedId
        assignee
        insertedBy
        subtaskId
        caseId
        billableItem
        description
        currency
        exchangeRate
        timeTakenSeconds
        travelHours
        otherHours
        totalBillableHours
        ratePerHour
        startTime
        stopTime
        status
        createdBy
        createdAt
        updatedBy
        modifiedBy
        updatedat
    }
}`;


export const allProformaFeeNotesQuotationsView = `{
    allProformaFeeNotesQuotationsView {
        id
        issueDate
        documentTypeId
        clientTypeId
        clientId
        clientName
        caseId
        caseNumber
        caseTitle
        caseDescription
        caseSummary
        caseCategoryId
        caseCategory
        caseSubcategoryId
        caseSubcategory
        caseStatus
        assignedTo
        dateOpened
        dateClosed
        priority
        amount
        statusId
        dueDate
        currencyId
        exchangeRate
        companyId
        company
        isActive
        createdBy
        createdDate
        updatedBy
        updatedDate
        approvedBy
    }
}`;
export const allCreditNotesView = `{
    allCreditNotesView {
        id
        issueDate
        documentTypeId
        documentTypeName
        clientTypeId
        clientId
        clientName
        caseId
        caseNumber
        caseTitle
        caseDescription
        caseSummary
        caseCategoryId
        caseCategory
        caseSubcategoryId
        caseSubcategory
        caseStatus
        assignedTo
        dateOpened
        dateClosed
        priority
        amount
        statusId
        statusName
        dueDate
        currencyId
        exchangeRate
        companyId
        company
        feeNoteId
        feeNoteIssueDate
        feeNoteAmount
        feeNoteDocumentTypeId
        feeNoteStatusId
        isActive
        createdBy
        createdDate
        updatedBy
        updatedDate
        approvedBy
    }
}`;


export const caseTaskForDashboard = `{
    recentCasesDynamic {
        id
        caseId
        asigneeId
        caseNumber
        title
        firstName
        lastName
        description
        caseDescription
        isActive
        done
        statusFlag
        dueDate
        createdDate
        regionId
        branchId
        companyId
        company
    }
}`;

export const caseMonthlyCasesStatististics = `
{
  monthlyStatisticsByYear(year: 2024) {
    assignedCases
    assignedCasesColor
    closedCases
    closedCasesColor
    inprogressCases
    inprogressCasesColor
    month
    newCases
    newCasesColor
  }
}
`;
export const getStorageData = `
{
    storageData {
        storage
        value
        label
        color
    }
}`;

export const allAdhocSmS = `
{
    smSesByCompany {
        messageId
        phoneNumber
        body
        sentDateTime
        status
        firstName
        lastName
     
     
    }
}
`;
export const allAdhocEmails = `{
    emailsByCompany {
        messageId
        recipientEmail
        subjectTitle
        body
        sentDateTime
        status
     
    }
}
`;

export const allGenders = `
{
    allGenders {
        id
        gender
        createdDate
        createdBy
        updatedBy
        updatedDate
    }
}`;
export const allSubRights = `
 {
    allSubRights {
        id
        title
        icon
        action
        rightId
        isActive
        statusFlag
        createdBy
        createdDate
        updatedBy
        updatedDate
        companyId
        company
    }
}`;
export const allRights = `{
    allRights {
     id
        title
        icon
        action
        moduleId
        module
        isActive
        statusFlag
        createdBy
        createdDate
        updatedBy
        updatedDate
        companyId
        company
        
    }
}`;
export const allRoleGroups = `{
    allRoleGroups {
        id
        roleGroup
        isActive
        statusFlag
        createdBy
        createdDate
        updatedBy
        updatedDate
        companyId
        company     
    }
}
`;

export const recentCaseTasks = `
{
    recentCaseTasks(taskModel: { companyId: null }) {
        id
        description
        caseId
        caseTitle
        assigneeFirstName
        assigneeLastName
        isActive
        statusFlag
        dueDate
        createdDate
        asigneeId
        createdBy
        companyId
        done
    }
}`;
export const allProcessFlows = `{
    allRoleGroups {
        id
        roleGroup
     
    }
}
`;
export const allReportTypes = `
{
    reportTypes {
        id
        majorClassificationID
        majorClassification
        minorClassificationID
        minorClassification
        reportName
        createdBy
        createdDate
        updatedBy
        updatedDate
    }
}
`;
export const allReportsMajorClassifications = `
    {
    reportsMajorClassifications {
        id
        majorClassification
        createdBy
        createdDate
        updatedBy
        updatedDate
    }
  }
  `;

export const allReportMinorClassifications = `
{
    reportsMinorClassifications {
        id
        majorClassificationID
        majorClassification
        minorClassification
        createdBy
        createdDate
        updatedBy
        updatedDate
    }
}`;

export const AllClientTypes = `
query AllClientTypes {
    allClientTypes {
        id
        clientType
        // Only include essential fields for the dropdown logic and display
    }
}
`;


export const ProformaQuotationDocumentsTypes = `
 {
    proformaQuotationDocumentsTypes {
        id
        documentTypeName
    }
}
`;

export const FeeNoteDocumentsTypes = `
 {
    feeNoteDocumentsTypes {
        id
        documentTypeName
    }
}
`;

export const currency = `
 {
    currency {
        id
        currencyCode
        currencyName
        exchangeRate
        baseCurrencyId
    }
}
`;
export const ClientTypes = `
 {
    clientTypes {
        id
        clientType
    }
}
`;
 

export const allFeeNotesView = `{
allFeeNotesView {
        id
        issueDate
        documentTypeId
        documentTypeName
        clientTypeId
        clientId
        clientName
        caseId
        caseNumber
        caseTitle
        caseDescription
        caseSummary
        caseCategoryId
        caseCategory
        caseSubcategoryId
        caseSubcategory
        caseStatus
        assignedTo
        dateOpened
        dateClosed
        priority
        amount
        statusId
        statusName
        dueDate
        currencyId
        exchangeRate
        companyId
        company
        proformaFeeNoteQuotationId
        withholdingTaxId
        withholdingTaxAmount
        isActive
        createdBy
        createdDate
        updatedBy
        updatedDate
        balance
        approvedBy
    }
}`;
export const AllApprovedFeeNotes = `{
allApprovedFeeNotesView {
        id
        issueDate
        documentTypeId
        documentTypeName
        clientTypeId
        clientId
        clientName
        caseId
        caseNumber
        caseTitle
        caseDescription
        caseSummary
        caseCategoryId
        caseCategory
        caseSubcategoryId
        caseSubcategory
        caseStatus
        assignedTo
        dateOpened
        dateClosed
        priority
        amount
        statusId
        statusName
        dueDate
        currencyId
        exchangeRate
        companyId
        company
        proformaFeeNoteQuotationId
        withholdingTaxId
        withholdingTaxAmount
        isActive
        createdBy
        createdDate
        updatedBy
        updatedDate
        balance
        approvedBy
    }
}`;
export const feeNoteByIdQuery = `
  query FeeNotesById($feeNotes: FeeNotesInput) {
    feeNotesById(feeNotes: $feeNotes) {
      id
      issueDate
      documentTypeId
      clientTypeId
      clientId
      clientName
      caseId
      caseNumber
      caseTitle
      amount
      statusId
      dueDate
      currencyId
      exchangeRate
      bankAccountId
      companyId
      regionId
      branchId
      company
      proformaFeeNoteQuotationId
      isActive
      createdBy
      createdDate
      updatedBy
      updatedDate
      approvedBy
      approvedDate
    }
  }
`;


export const allFeeNotesLinesQuery = `
    query AllFeeNotesLinesByFeeNoteId2($feeNotesLines: FeeNotesLinesInput) {
        allFeeNotesLinesByFeeNoteId(feeNotesLines: $feeNotesLines) {
            id
            feeNoteId
            description
            accountSubCategoryId
            amount
            vatId
            vatAmount
            isActive
            createdBy
            createdDate
            updatedBy
            updatedDate
        }
    }
`;

export const allImprestLinesQuery = `
    query ImprestApplicationLinesByImprestId($ImprestApplicationLines: ImprestIdLineInput) {
        imprestApplicationLinesByImprestId(imprestApplicationLines: $imprestId) {
            id
        imprestId
        expenseTypeId
        accountId
        description
        amountRequested
        costCenterId
        projectId
        createdDate
        createdBy
        updatedDate
        updatedBy
        isActive
        }
    }
`;
export const allReceiptsView = `{
    allReceiptsView {
        id
        receiptDate
        clientTypeId
        clientId
        clientName
        caseId
        caseNumber
        caseTitle
        caseDescription
        caseSummary
        caseCategoryId
        caseCategory
        caseSubcategoryId
        caseSubcategory
        caseStatus
        assignedTo
        dateOpened
        dateClosed
        priority
        feeNoteId
        feeNoteDocumentTypeId
        modeOfReceiptId
        modeOfReceiptName
        modeOfReceiptDescription
        referenceNumber
        accountSubCategoryId
        accountSubCategoryName
        accountId
        accountName
        currencyId
        currencyName
        exchangeRate
        totalAmount
        companyId
        companyName
        branchId
        branchName
        regionId
        regionName
        isActive
        createdBy
        createdDate
        updatedBy
        updatedDate
        approvedBy
        approvedDate
        isPosted
    }
}`;
export const allModeOfReceipts = `{
  allModeOfReceipts {
    id
    name
    description
    isActive
    createdBy
    createdDate
    updatedBy
    updatedDate
  }
}`;

export const ProformaFeeNotesQuotationsById = ` {
    proformaFeeNotesQuotationsById(proformaFeeNotesQuotationsModel: $model) {
      id
      issueDate
      clientName
      caseNumber
      amount
      currencyId
      exchangeRate
    }
  }
`;

export const allPurchaseInvoiceView = `{
  allPurchaseInvoiceView {
    id
    invoiceNumber
    issueDate
    supplierId
    supplierName
    loNumber
    dueDate
    statusId
    statusName
    approvedBy
    approvedByName
    approvedDate
    currencyId
    currencyCode
    exchangeRate
    withholdingTaxId
    withholdingTaxAmount
    totalAmount
    companyId
    companyName
    branchId
    bankAccountId
    bankAccountName
    notes
    isActive
    createdBy
    createdDate
    updatedBy
    updatedDate
    balance
  }
}`;

export const GROUPED_JOURNAL_LINES_QUERY = `
  query groupedJournalLinesByColumnValues {
    groupedJournalLinesByColumnValues(accountSubCategoryId: $accountSubCategoryId, identifierType: $identifierType) {
      journalLineID
      journalEntryID
      accountID
      debit
      credit
      description
      createdDate
      createdBy
      caseId
      cancelled
      applicationId
      applicationType
    }
  }
`;

// export const allSuppliers = `{
//   allSuppliers {
//         id
//         supplierName
//         contactNumber
//         email
//         address
//         registrationNumber
//         taxIdentificationNumber
//         contactPersonName
//         contactPersonEmail
//         contactPersonPhone
//         industrySector
//         dateAdded
//         notes
//         isActive
//         statusFlag
//         createdBy
//         createdDate
//         updatedBy
//         updatedDate
//         companyId
//         company
//     }
// }`;

// export const allAccounts = `{
// allAccounts {
//         id
//         status
//         accountName
//         accountNumber
//         accountType
//         companyId
//         company
//         currencyId
//         currency
//         isActive
//         statusFlag
//         createdBy
//         createdDate
//         updatedBy
//         updatedDate
//         identifierType
//         identifierId
//         accountSubcategoryId
//         balance
//         financialStatementType
//         normalBalance
//         closingBalance
//     }


// }`;